<template>
    <TsCard
      :append-class="`flex flex-col max-md:p-2 h-full w-[300px] ${appendClass}`"
      footer-class="mt-auto"
      dataTestid="you-may-also-like-card"
      noBorder
      noShadow
    >
      <template #header>
        <NuxtLinkWithLocale :to="url">
          <TsImage
            :src="image"
            :alt="title"
            class="rounded-lg w-full"
            dataTestid="you-may-also-like-card-hero-banner"
            loading="lazy"
          />
        </NuxtLinkWithLocale>
      </template>
      <template #content>
        <NuxtLinkWithLocale :to="url">
          <TsTypography
            append-class="mb-0 text-idle-black line-clamp-1"
            weight="bold"
            dataTestid="you-may-also-like-card-title"
            >{{ title }}</TsTypography
          >
        </NuxtLinkWithLocale>
        <TsTypography
          append-class="mb-2 w-full line-clamp-3"
          dataTestid="you-may-also-like-card-excerpt"
        >
          {{ excerpt }}
        </TsTypography>
        <NuxtLink :to="url">
          <TsTypography
            weight="bold"
            dataTestid="you-may-also-like-card-readmore"
            append-class="underline mb-0 underline-offset-2 cursor-pointer text-info"
          >
            {{useTranslation('readMore','Lees meer')}}
          </TsTypography>
        </NuxtLink>
      </template>
    </TsCard>
  </template>
  
  <script setup lang="ts">
  const TsCard = defineAsyncComponent(
      () => import('~/components/organisms/TsCard.vue')
  );

  type Props = {
    dataTestid: string;
    id: number;
    title: string;
    excerpt: string;
    url: string;
    image: string;
    appendClass?: string;
  };
  
  defineProps<Props>()
  </script>
  